/* eslint-disable */
/*
* shared.js
*
* Description: Holds 'Stores' Logic for Module:'Crewplanning2 - Calendar'.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2 - Crewplanning"
* Copyright 2018,2019,2020,2021,2022,2023 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import router from '../../../routers/router'; // after login
import { eventBus } from '../../../main';
import {
    CONF_SCHEDULERS_SYNCHRONIZED,
} from '../../../config.js'


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> Drawer -----------------------------------------
    barColor: 'rgba(45, 62, 82, 1), rgba(45, 62, 82, 1)',
    barImage: '', /* is OFF right now, LEA */
    drawer: null,

    // >>> Login ------------------------------------------
    sharedLoginResults: {}, // Results::Login
    idGroup: null,
    idResource: null,
    idUser: null,
    realName: null,
    userName: null,
    shared_usersGrantsList: [],

    // >>> Path -------------------------------------------
    shared_Path: null,

    // >>> Airports ---------------------------------------
    sharedAirportResults: {}, // Results::Airports
    // >>> Aircrafts --------------------------------------
    people_aircraftConfigs: [],
    shared_airportTaxes: [],
    // >>> Countries --------------------------------------
    people_Countries: [],
    // >>> Bases ------------------------------------------
    people_Bases: [],

    // >>> All Employees ----------------------------------
    shared_AllEmployeesResults: [], // Results::'All Employees'

    // >>> Hotels -----------------------------------------
    sharedHotelsResults: {}, // Results::Hotels
    sharedHotelsResultsFiltered: [], // Filtered Hotels List by countryid

    // >>> Trainings --------------------------------------
    sharedTrainingsResults: {}, // Results::Trainings

    // >>> All Employess ----------------------------------
    shared_AllEmployeesResults: {}, // Results::'All Employees'

    // >>> Settings: 'Calendar' Mode ----------------------
    shared_SchedulersSynchronizedMode: CONF_SCHEDULERS_SYNCHRONIZED,
    shared_SchedulerPartneringMode: false,
    shared_Scheduler_Preset: 'hourPreset',

    // >>> Warning ----------------------------------------
    shared_Warning: null

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Shared' - 'Login'
    ***************************************************************************/
    /***************************************************************************
    * isAuthenticated()
    *
    * Desc: Dear ... are we authenticated?
    * Note:
    *
    */
    isAuthenticated: state => {

        return state.idUser !== null;

    }, // eo function isAuthenticated()


    /***************************************************************************
    * getIdUser()
    *
    * Desc:
    * Note:
    *
    */
    getIdUser: state => {

        return state.idUser;

    }, // eo function getIdUser()


    /***************************************************************************
    * getIdGroup()
    *
    * Desc:
    * Note: Group 1 === Admin
    *
    */
    getIdGroup: state => {

        return state.idGroup;

    }, // eo function getIdGroup()


    /***************************************************************************
    * getIdResource()
    *
    * Desc:
    * Note:
    *
    */
    getIdResource: state => {

        return state.idResource;

    }, // eo function getIdResource()


    /***************************************************************************
    * get_shared_IsDutyAccessAllowed()
    *
    * Desc: Reads from 'User Grants'. (from '/login' Response).
    * Note: Getter with Payload!
    *
    * Grants:
    * sc2.calendar.readonly => Readonly for Calendar [ok]
    * sc2.flights.readonly => Readonly for Calendar [ok]
    * sc2.calendar.admin => All allowed in Calendar
    * sc2.flights.admin => All allowed in Flights
    *
    * sc2.calendar.available => access allowed
    * sc2.calendar.dayoff => ...
    * sc2.calendar.freeday => ...
    * sc2.calendar.hotel => ...
    * sc2.calendar.meeting => ...
    * sc2.calendar.office => ...
    * sc2.calendar.proceeding => ...
    * sc2.calender.reserve => ...
    * sc2.calendar.sickness => ...
    * sc2.calendar.vacation => ...
    * sc2.calendar.unabletofly => ...
    * sc2.calendar.standby => ...
    * sc2.calendar.training => ...
    * sc2.calendar.switchduty => ...
    *
    * Note: e.g.: payload :: { grant: 'sc2.calendar.readonly', scheduler: 'CALENDAR' }
    *
    */
    get_shared_IsDutyAccessAllowed: state => payload => {

        let accessAllowed = false;


        // >>> --------------------------------------------
        if (payload.scheduler === 'CALENDAR') {
            // Step 1: 'Admin'?
            if (state.shared_usersGrantsList.includes('sc2.calendar.admin')) {
                accessAllowed = true;
            }

            // Step 2: If no 'Admin' check single Duties
            if (accessAllowed === false) {
                if (state.shared_usersGrantsList.includes(payload.grant)) {
                    accessAllowed = true;
                }
            }

        }


        return accessAllowed;

    }, // eo function get_shared_IsDutyAccessAllowed()


    /***************************************************************************
    * get_shared_IsEditingInThePastAllowed()
    *
    * Desc: Reads from 'User Grants'. (from '/login' Response).
    * Note: Getter with Payload!
    * Note: Ticket #4
    *
    */
    get_shared_IsEditingInThePastAllowed: state => {

        let accessAllowed = false;


        if (state.shared_usersGrantsList.includes('sc2.calendar.admin.past')) {
            accessAllowed = true;
        }


        return accessAllowed;

    }, // eo function get_shared_IsEditingInThePastAllowed()


    /***************************************************************************
    * get_shared_IsSchedulerReadOnly()
    *
    * Desc:
    * Note:
    *
    */
    get_shared_IsSchedulerReadOnly: state => payload => {

        let isReadOnly = false;


        // >>> --------------------------------------------
        if (payload.scheduler === 'CALENDAR') {
            if (state.shared_usersGrantsList.includes('sc2.calendar.readonly')) {
                isReadOnly = true;
            }
        }

        // >>> --------------------------------------------
        if (payload.scheduler === 'FLIGHTS') {
            if (state.shared_usersGrantsList.includes('sc2.calendar.flights.readonly')) {
                isReadOnly = true;
            }

        }

        return isReadOnly;

    }, // eo function get_shared_IsSchedulerReadOnly()




    /***************************************************************************
    * Getters: 'Shared' - 'Path'
    ***************************************************************************/
    /***************************************************************************
    * get_shared_Path()
    *
    * Desc:
    * Note:
    *
    */
    get_shared_Path: state => {

        return state.shared_Path;

    }, // eo function get_shared_Path()




    /***************************************************************************
    * Getters: 'Shared' - AircraftConfigs
    ***************************************************************************/
    /***************************************************************************
    * get_AircraftConfigs()
    *
    * Desc:
    * Note:
    *
    */
    get_AircraftConfigs: state => {

        return state.people_aircraftConfigs;

    }, // eo function get_AircraftConfigs()




    /***************************************************************************
    * Getters: 'Shared' - AirportTaxes
    ***************************************************************************/
    /***************************************************************************
    * get_AirportTaxes()
    *
    * Desc:
    * Note:
    *
    */
    get_AirportTaxes: state => {

        return state.shared_airportTaxes;

    }, // eo function get_AirportTaxes()


    /***************************************************************************
    * get_Airports()
    *
    * Desc:
    * Note:
    *
    */
    get_Airports: state => {

        return state.sharedAirportResults;

    }, // eo function get_Airports()




    /***************************************************************************
    * Getters: 'Shared' - Countries
    ***************************************************************************/
    /***************************************************************************
    * get_Countries()
    *
    * Desc:
    * Note:
    *
    */
    get_Countries: state => {

        return state.people_Countries;

    }, // eo function get_Countries()




    /***************************************************************************
    * Getters: 'Shared' - Bases
    ***************************************************************************/
    /***************************************************************************
    * get_Bases()
    *
    * Desc:
    * Note:
    *
    */
    get_Bases: state => {

        return state.people_Bases;

    }, // eo function get_Bases()




    /***************************************************************************
    * Getters: 'Shared' - 'All Employees'
    ***************************************************************************/
    /***************************************************************************
    * get_AllEmployees()
    *
    * Desc:
    * Note: Still empty!
    *
    */
    get_AllEmployees: state => {

        return state.shared_AllEmployeesResults;

    }, // eo function get_AllEmployees()




    /***************************************************************************
    * Getters: CrewCalendar - 'Hotels'
    ***************************************************************************/
    /***************************************************************************
    * get_Hotels()
    *
    * Desc:
    * Note:
    *
    */
     get_Hotels: state => {

        return state.sharedHotelsResults;

    }, // eo function get_Hotels()


    /***************************************************************************
    * get_FilteredHotels()
    *
    * Desc:
    * Note:
    *
    */
    get_FilteredHotels: state => {

        return state.sharedHotelsResultsFiltered;

    }, // eo function get_FilteredHotels()




    /***************************************************************************
    * Getters: CrewCalendar - 'Trainings'
    ***************************************************************************/
    /***************************************************************************
    * get_Trainings()
    *
    * Desc:
    * Note:
    *
    */
    get_Trainings: state => {

        return state.sharedTrainingsResults;

    }, // eo function get_Trainings()




    /***************************************************************************
    * Getters: CrewCalendar - 'All Employees'
    ***************************************************************************/
    /***************************************************************************
    * get_AllEmployees()
    *
    * Desc:
    * Note:
    *
    */
    get_AllEmployees: state => {

        return state.shared_AllEmployeesResults;

    }, // eof get_AllEmployees()




    /***************************************************************************
    * Getters: Settings: 'Calendar' Mode & more
    ***************************************************************************/
    /***************************************************************************
    * get_shared_SchedulersSynchronizedMode()
    *
    * Desc: Return 'Calendar' Mode.
    * Note:
    *
    */
    get_shared_SchedulersSynchronizedMode: state => {

        return state.shared_SchedulersSynchronizedMode;

    }, // eo function get_shared_SchedulersSynchronizedMode()


    /***************************************************************************
    * get_shared_SchedulerPartneringMode()
    *
    * Desc: Return 'Schedulers Partnering' Mode.
    * Note:
    *
    */
    get_shared_SchedulerPartneringMode: state => {

        return state.shared_SchedulerPartneringMode;

    }, // eo function get_shared_SchedulerPartneringMode()


    /***************************************************************************
    * get_shared_Scheduler_Preset()
    *
    * Desc: Return Scheduler Preset.
    * Note:
    *
    */
    get_shared_Scheduler_Preset: state => {

        return state.shared_Scheduler_Preset;

    }, // eof get_shared_Scheduler_Preset()




    /***************************************************************************
    * Getters: 'Shared' - Set Warning (Dialog Popover)
    ***************************************************************************/
    /***************************************************************************
    * get_Shared_Warning()
    *
    * Desc: Return Warning Object.
    * Note:
    *
    */
    get_shared_Warning: state => {

        return state.shared_Warning;

    }, // eo function get_shared_Warning()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'Shared' - 'Drawer'
    ***************************************************************************/
    /***************************************************************************
    *
    * Desc:
    * Note:
    *
    */
    SET_BAR_IMAGE: (state, payload) => {

        state.barImage = payload;

    }, // eo function SET_BAR_IMAGE()

    SET_DRAWER: (state, payload) => {

        state.drawer = payload;

    }, // eo function SET_DRAWER()

    SET_SCRIM: (state, payload) => {

        state.barColor = payload;

    }, // eo function SET_SCRIM()




    /***************************************************************************
    * Mutations: 'Shared' - 'Login'
    ***************************************************************************/
    /***************************************************************************
    * mut_userLogin()
    *
    * Desc: User Login.
    * Note: NEW! We now have 'grants' in Logins Response.
    * Note: Redirect to '/' Dashboard(!) (bec: First need to check 'grants').
    *
    */
    mut_userLogin: (state, payload) => {

        state.sharedLoginResults = payload;
        state.idGroup = payload.idGroup;
        state.idResource = payload.idResource;
        state.idUser = payload.idUser;
        state.realName = payload.realName;
        state.userName = payload.userName;
        state.shared_usersGrantsList = payload.grants;

        router.push('/');

    }, // eo function mut_userLogin()




    /***************************************************************************
    * Mutations: 'Shared' - 'Path'
    ***************************************************************************/
    /***************************************************************************
    * mut_set_Path()
    *
    * Desc:
    * Note:
    *
    */
    mut_set_Path: (state, payload) => {

        state.shared_Path = payload;

    }, // eo function mut_set_Path()




    /***************************************************************************
    * Mutations: 'Shared' - 'Countries'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_Countries()
    *
    * Desc: Save countries to state.
    * Note: Countries are not sorted, sort them by name.
    *
    */
    mut_call_Countries: (state, payload) => {

        let sortedCountries = [...payload];


        sortedCountries.sort((a, b) => a.name < b.name ? -1 : 1);

        state.people_Countries = sortedCountries;

    }, // eo function mut_call_Countries()




    /***************************************************************************
    * Mutations: 'Aircrafts'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_AircraftConfigs()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_AircraftConfigs: (state, payload) => {

        state.people_aircraftConfigs = payload;

    }, // eo function mut_call_AircraftConfigs()


    /***************************************************************************
    * mut_load_Airports()
    *
    * Desc: Load Airports.
    * Note:
    *
    */
    mut_load_Airports: (state, payload) => {

        payload.sort((a,b) => (a.aptCode > b.aptCode) ? 1 : ((b.aptCode > a.aptCode) ? -1 : 0));
        state.sharedAirportResults = payload;

    }, // eo function mut_load_Airports()




    /***************************************************************************
    * Mutations: 'AirportTaxes'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_AirportTaxes()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_AirportTaxes: (state, payload) => {

        let sortedAirports = [...payload];


        sortedAirports.sort((a, b) => a.aptCode < b.aptCode ? -1 : 1);
        state.shared_airportTaxes = sortedAirports;

    }, // eo function mut_call_AirportTaxes()



    /***************************************************************************
    * Mutations: 'Shared' - 'Bases'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_Bases()
    *
    * Desc: Save countries to state.
    * Note:
    *
    */
    mut_call_Bases: (state, payload) => {

        state.people_Bases = payload;

    }, // eo function mut_call_Bases()




    /***************************************************************************
    * Mutations: 'Shared' - 'Save Duty Plan Changes'
    ***************************************************************************/
    /***************************************************************************
    * mut_update_DutyPlanChanges()
    *
    * Desc: Update List 'All Employees' with new 'created' TimeStamp.
    * Note:
    *
    */
    mut_update_DutyPlanChanges: (state, payload) => {

        let sr = null;


        payload.forEach((item, i) => {
            sr = state.shared_AllEmployeesResults.find(resource => resource.id === item.idResource);
            sr.lastDutyPlanRelease = item.created;
        });

    }, // eo function mut_update_DutyPlanChanges()




    /***************************************************************************
    * Mutations: 'Shared' - 'All Employees'
    ***************************************************************************/
    /***************************************************************************
    * mut_load_AllEmployees()
    *
    * Desc: After Load 'All Employees'.
    * Note:
    *
    */
    mut_load_AllEmployees: (state, payload) => {

        payload.sort((a, b) => (a.genLastname > b.genLastname) ? 1 : ((b.genLastname > a.genLastname) ? -1 : 0));
        state.shared_AllEmployeesResults = payload;

    }, // eo function mut_load_AllEmployees()



    /***************************************************************************
    * Mutations: Crewcalendar - 'Hotels'
    ***************************************************************************/
    /***************************************************************************
    * mut_load_Hotels()
    *
    * Desc: After Load Hotels.
    * Note:
    *
    */
     mut_load_Hotels: (state, payload) => {

        payload.sort((a,b) => (a.hotelName > b.hotelName) ? 1 : ((b.hotelName > a.hotelName) ? -1 : 0));
        state.sharedHotelsResults = payload;

    }, // eo function mut_load_Hotels()


    /***************************************************************************
    * mut_filter_Hotels()
    *
    * Desc:
    * Note: List filtered.
    *
    */
    mut_filter_Hotels: (state, payload) => {

        let hotels = [];


        state.sharedHotelsResults.forEach((hotel, i) => {

            if (payload !== undefined && payload !== null) {
                if (hotel.idCountry === payload) {
                    hotels.push(
                        {
                            hotelname: hotel.hotelName.trim() + ', ' + hotel.city,
                            hotelid: hotel.id
                        }
                    );
                }
            }
        });

        state.sharedHotelsResultsFiltered = hotels;

    }, // eo function mut_filter_Hotels()




    /***************************************************************************
    * Mutations: Crewcalendar - 'Trainings'
    ***************************************************************************/
    /***************************************************************************
    * mut_load_Trainings()
    *
    * Desc: After Load Trainings.
    * Note:
    *
    */
    mut_load_Trainings: (state, payload) => {

        payload.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
        state.sharedTrainingsResults = payload;

    }, // eof mut_load_Trainings()




    /***************************************************************************
    * Mutations: Crewcalendar - 'All Employees'
    ***************************************************************************/
    /***************************************************************************
    * mut_load_Trainings()
    *
    * Desc: After Load 'All Employees'.
    * Note:
    *
    */
    mut_load_AllEmployees: (state, payload) => {

        state.shared_AllEmployeesResults = payload;

    }, // eof mut_load_AllEmployees()




    /***************************************************************************
    * Mutations: Settings: 'Calendar' Mode & more
    ***************************************************************************/
    /***************************************************************************
    * mut_set_Calendar_Mode()
    *
    * Desc: Set 'Calendar' Mode.
    * Note:
    *
    */
    mut_set_Calendar_Mode: (state, payload) => {

        state.shared_SchedulersSynchronizedMode = payload;

    }, // eo function mut_set_Calendar_Mode()


    /***************************************************************************
    * mut_set_SchedulerPartnering_Mode()
    *
    * Desc: Set
    * Note:
    *
    */
    mut_set_SchedulerPartnering_Mode: (state, payload) => {

        state.shared_SchedulerPartneringMode = payload;
        eventBus.$emit('switchschedulerpartneringmode', state.shared_SchedulerPartneringMode);

    }, // eo function mut_set_SchedulerPartnering_Mode()


    /***************************************************************************
    * mut_set_SchedulersPreset()
    *
    * Desc: Set Schedulers Preset.
    * Note:
    *
    */
    mut_set_SchedulersPreset: (state, payload) => {

        state.shared_Scheduler_Preset = payload;
        eventBus.$emit('calibratezoomlevel', state.shared_Scheduler_Preset); // emit ..

    }, // eof mut_set_SchedulersPreset()




    /***************************************************************************
    * Mutations: 'Shared' - Set Warning (Dialog Popover)
    ***************************************************************************/
    /***************************************************************************
    * mut_set_Warning()
    *
    * Desc:
    * Note:
    *
    */
    mut_set_Warning: (context, payload) => {

        state.shared_Warning = payload;

    }, // eo function mut_set_Warning()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Shared' - 'Login'
    ***************************************************************************/
    /*************************************************************************** Step 1
    * actn_userLogin()
    *
    * Desc: (Call) - User Login.
    * Note: Set Headers Authorization here!
    * Note: Load Countries & More from here.
    * Note: NEW! We now have 'grants' in Logins Response.
    *
    *
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_userLogin: (context, payload) => {

        let hdrs = '',
            url = 'acm/acl/login';


        // >>> Set 'Authorization' Header -------
        axios.defaults.headers.Authorization = Vue.prototype.$make_basic_auth(payload);

        Vue.prototype.$vp_m();
        axios.get(url, payload.params)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_userLogin', response.data);             // calling mutation

                        context.dispatch("actn_call_getCountries", {});             // load countries
                        // context.dispatch("actn_call_getAirportTaxes", {});       // load airportTaxes
                        // context.dispatch("actn_call_getHotelGoodies", {});       // load hotel gooddies
                        context.dispatch("actn_call_getAircraftConfigs", {});       // load aircrafts
                        // context.dispatch("actn_call_getBlocktimes", {});         // load block times
                        context.dispatch("actn_call_getAirport", {});               // load airports

                        context.dispatch("actn_call_crews_getResourcesOfDepartment", { department: '11', secondLoad: false }); // load airports
                        context.dispatch("actn_call_crews_getResourcesOfDepartment", { department: '12', secondLoad: true }); // load airports

                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_userLogin()


    /***************************************************************************
    * actn_userLogout()
    *
    * Desc:
    * Note:
    *
    */
    actn_userLogout: (context, payload) => {


    }, // eo function actn_userLogout()


    /***************************************************************************
    * actn_userSignup()
    *
    * Desc:
    * Note:
    *
    */
    actn_userSignup: (context, payload) => {


    }, // eo function actn_userSignup()




    /***************************************************************************
    * Actions: 'Shared' - 'Path'
    ***************************************************************************/
    /***************************************************************************
    * actn_set_Path()
    *
    * Desc:
    * Note:
    *
    */
    actn_set_Path: (context, payload) => {

        context.commit('mut_set_Path', response.data);

    }, // eo function actn_set_Path()




    /***************************************************************************
    * Actions: 'Shared' - Load Countries
    ***************************************************************************/
    /***************************************************************************
    * Call::'/info/countries'
    *
    * Desc: Call: Get List of Countries.
    * Note:
    *
    */
    actn_call_getCountries: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/info/countries')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_Countries', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getCountries()




    /***************************************************************************
    * Actions: 'Shared' - - Load Bases
    ***************************************************************************/
    /***************************************************************************
    * Call::'/humanresources/bases'
    *
    * Desc: Call: Get List of Bases.
    * Note:
    *
    */
    actn_call_getBases: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/humanresources/bases')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_Bases', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getBases()




    /***************************************************************************
    * Actions: 'Shared' - Load Aircraft(s)
    ***************************************************************************/
    /***************************************************************************
    * Call::'acm/forms/aircraftconfigs'
    *
    * Desc: Call: Get List of Aircrafts.
    * Note:
    *
    */
    actn_call_getAircraftConfigs: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/acm/forms/aircraftconfigs')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_AircraftConfigs', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getAircraftConfigs()




    /***************************************************************************
    * Actions: 'Shared' - Load Airport Taxes
    ***************************************************************************/
    /***************************************************************************
    * Call::'/acm/airport/taxes'
    *
    * Desc: Call: Get List of Airport Taxes.
    * Note:
    *
    */
    actn_call_getAirportTaxes: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/acm/airport/taxes')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_AirportTaxes', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getAircraftConfigs()


    /***************************************************************************
    * actn_call_getAirport()
    *
    * Desc: (Call) - Load Airports right after Login.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_call_getAirport: (context, payload) => {

        let hdrs = '',
            url = 'acm/airport/taxes';


        axios.get(url, payload.params)
            .then(function (response) {
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_load_Airports', response.data);     // calling mutation
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                };
            })
            .catch(function (error) {
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getAirport()




    /***************************************************************************
    * Actions: 'Shared' - 'All Employees'
    ***************************************************************************/
    /***************************************************************************
    * actn_call_load_AllEmployees()
    *
    * Desc: (Call) - Load 'All Employees'
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note:
    *
    */
    actn_call_load_AllEmployees: (context, payload) => {

        let hdrs = '';


        axios.get('/humanresources/resource/active', payload.params)
            .then(function (response) {
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_load_AllEmployees', response.data); // calling mutation
                        eventBus.$emit('onallemployeesloaded', {});             //
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                }
            })
            .catch(function (error) {
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_load_AllEmployees()




    /***************************************************************************
    * Actions: 'Shared' - 'All Employees - Save Duty Plan Changes'
    ***************************************************************************/
    /***************************************************************************
    * Call: '/humanresources/resource/dutyplan/generate'
    *
    * Desc: (Call) - Update multiple Ressources. Save Duty Plan Changes.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_update_DutyPlanChanges: (context, payload) => {

        let hdrs = '';


        Vue.prototype.$vp_m();
        axios.put('/humanresources/resource/dutyplan/generate', payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_update_DutyPlanChanges', response.data); // calling mutation

                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Save Duty Plan Changes - Updated'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                }
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_update_DutyPlanChanges()




    /***************************************************************************
    * Actions: CrewCalendar - 'Hotels'
    ***************************************************************************/
    /***************************************************************************
    * actn_load_Hotels()
    *
    * Desc: (Call) - Load Hotels right Crewcalendar:mounted.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: Build filtered Hotels List after Load.
    * TODO: May this Call does not belong into shared.js?
    *
    */
    actn_load_Hotels: (context, payload) => {

        let hdrs = '',
            url = 'humanresources/config/hotel';


        axios.get(url, payload.params)
            .then(function (response) {
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_load_Hotels', response.data);       // calling mutation
                        context.commit('mut_filter_Hotels', null);              // calling mutation
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                };
            })
            .catch(function (error) {
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_load_Hotels()


    /***************************************************************************
    * actn_filter_Hotels()
    *
    * Desc: Filter HotelList by Country Id.
    * Note:
    *
    */
    actn_filter_Hotels: (context, payload) => {

        context.commit('mut_filter_Hotels', payload);

    }, // eof actn_filter_Hotels()




    /***************************************************************************
    * Actions: CrewCalendar - 'Trainings'
    ***************************************************************************/
    /***************************************************************************
    * actn_load_Trainings()
    *
    * Desc: (Call) - Load Trainings right Crewcalendar:mounted.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note:
    * TODO: May this Call does not belong into shared.js?
    *
    */
    actn_load_Trainings: (context, payload) => {

        let hdrs = '',
            url = 'humanresources/config/trainings/position/ALL';


        axios.get(url, payload.params)
            .then(function (response) {
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_load_Trainings', response.data);    // calling mutation
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                };
            })
            .catch(function (error) {
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eof actn_load_Trainings()




    /***************************************************************************
    * Actions: CrewCalendar - 'All Employees'
    ***************************************************************************/
    /***************************************************************************
    * actn_load_Trainings()
    *
    * Desc: (Call) - Load 'All Employees' right Crewcalendar:mounted.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note:
    * TODO: May this Call does not belong into shared.js?
    *
    */
    actn_load_AllEmployees: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/active';


        axios.get(url, payload.params)
            .then(function (response) {
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_load_AllEmployees', response.data); // calling mutation
                        eventBus.$emit('onallemployeesloaded', {});             //
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                };
            })
            .catch(function (error) {
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eof actn_load_AllEmployees()




    /***************************************************************************
    * Actions: Settings: 'Calendar' Mode & more
    ***************************************************************************/
    /***************************************************************************
    * actn_set_Calendar_Mode()
    *
    * Desc: Set(tings) 'Calendar Mode' (only)
    * Note:
    *
    * @param {boolean} payload
    */
    actn_set_Calendar_Mode: (context, payload) => {

        context.commit('mut_set_Calendar_Mode', payload);

    }, // eo function actn_set_Calendar_Mode()


    /***************************************************************************
    * actn_set_SchedulerPartnering_Mode()
    *
    * Desc: Set(tings) 'Scheduler Partnering' Mode
    * Note:
    *
    * @param {boolean} payload
    */
    actn_set_SchedulerPartnering_Mode: (context, payload) => {

        context.commit('mut_set_SchedulerPartnering_Mode', payload);

    }, // eo function actn_set_SchedulerPartnering_Mode()


    /***************************************************************************
    * actn_set_SchedulersPreset()
    *
    * Desc: Save the new Scheduler Preset.
    * Note:
    *
    * @param {string} payload ('overviewPreset' | 'hourPreset' | 'dayPreset')
    */
    actn_set_SchedulersPreset: (context, payload) => {

        context.commit('mut_set_SchedulersPreset', payload);

    }, // eo function actn_set_SchedulersPreset()




    /***************************************************************************
    * Actions: 'Shared' - Set Warning (Dialog Popover)
    ***************************************************************************/
    /***************************************************************************
    * actn_set_Warning()
    *
    * Desc:
    * Note:
    *
    */
    actn_set_Warning: (context, payload) => {

        context.commit('mut_set_Warning', payload);

    }, // eo function actn_set_Warning()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions
};
